export default function dateToField(d) {
  const dd = d ? new Date(d) : false;
  return (dd) ? dd.toLocaleString('pt-BR', 
    { 
      dateStyle: 'short', 
      timeStyle: 'short', 
      timeZone: 'UTC' 
    }
  ) : '';
}